























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { AppUserDayViewModel, TimeEntryDayApprovalEditModel, TimeEntryDayApprovalEnum } from '@/services/api/nswag/stapiclient_generated';
import { stTimeEntryDayApprovalApi } from '@/services/st-api';
import AppUser from '@/views/User/AppUser.vue';
import { formatNumber } from 'vue-currency-filter/dist/accounting';
import { getHours } from '@/utlitities/helper';

@Component({
  computed: {
    TimeEntryDayApprovalEnum() {
      return TimeEntryDayApprovalEnum;
    },
  },
  components: {},
})
export default class TeamOverviewApprovalDay extends Vue {
  @Prop() appUserId: number;
  @Prop() appUserDay: AppUserDayViewModel;
  @Prop() date: string;
  @Prop() mode: string;
  loading = true;
  popOverOpen = false;

  timeEntryDayApprovalEditModel: TimeEntryDayApprovalEditModel = TimeEntryDayApprovalEditModel.fromJS({});

  async mounted() {}

  @Emit('stateChanged')
  async approve() {
    this.loading = true;
    this.timeEntryDayApprovalEditModel.approvalEnum = TimeEntryDayApprovalEnum.IsApproved;
    this.timeEntryDayApprovalEditModel.approvalMode = this.mode;
    await stTimeEntryDayApprovalApi.setTimeEntryDayApproval(this.timeEntryDayApprovalEditModel);
    this.popOverOpen = false;
  }

  @Emit('stateChanged')
  async decline() {
    this.loading = true;
    this.timeEntryDayApprovalEditModel.approvalEnum = TimeEntryDayApprovalEnum.IsDeclined;
    this.timeEntryDayApprovalEditModel.approvalMode = this.mode;
    await stTimeEntryDayApprovalApi.setTimeEntryDayApproval(this.timeEntryDayApprovalEditModel);
    this.popOverOpen = false;
  }

  async openPopover() {
    this.popOverOpen = true;
    this.loading = true;
    this.timeEntryDayApprovalEditModel = await stTimeEntryDayApprovalApi.getTimeEntryDayApprovalEditModel(this.appUserId, this.date, this.mode);
    this.loading = false;
  }

  getDayTooltip(appUserDay: AppUserDayViewModel) {
    let comment = '';
    if (appUserDay.timeEntryDayApproval?.comment) {
      comment += '<br>' + appUserDay.timeEntryDayApproval.comment;
    }

    return {
      content: 'Sollstunden: ' + getHours(appUserDay.targetMinutesEffective) + ' h' + '<br>' + 'Iststunden: ' + getHours(appUserDay.durationMinutes) + ' h' + comment,
      isHtml: true,
    };
  }

  getApprovalClass(day: AppUserDayViewModel) {
    if (!day.timeEntryDayApproval) {
      return 'bg-white';
    }

    switch (day.timeEntryDayApproval.approvalEnum) {
      case TimeEntryDayApprovalEnum.None:
        return 'bg-white';
      case TimeEntryDayApprovalEnum.IsApproved:
        return 'bg-green-500';
      case TimeEntryDayApprovalEnum.IsSubmitted:
        return 'bg-orange-500';
      case TimeEntryDayApprovalEnum.IsSubmittedImplicitly:
        return 'bg-orange-300';
      case TimeEntryDayApprovalEnum.IsDeclined:
        return 'bg-red-500 text-white';
    }

    return 'bg-white';
  }
}
